var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"d-flex"},[_c('Sidebar'),_c('div',{staticClass:"w-100"},[_c('Header'),_c('div',{staticClass:"p-3 w-100",attrs:{"id":"body-layout"}},[_c('router-view')],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }